<template>
	<video controls controlsList="nodownload" disablePictureInPicture>
		<source :src="currentSrc + '#t=0.5'" :type="currentType" :label="currentPublicName">
		Your browser does not support the video tag.
	</video>
</template>

<script>
export default {
	name: 'VideoSourceComponent',
	props: ['videoURLs', 'resolution'],

	data() {
		return {
			currentSrc: '',
			currentType: '',
			currentPublicName: '',

		}
	},

	methods: {
		checkResolution() {
			let lastVal = 0
			let rightObj = {};
			for (let urlData of this.videoURLs) {
				let videoResMaxVal = urlData.height > urlData.width ? urlData.height : urlData.width

				if(Math.abs(this.resolution - videoResMaxVal) <= Math.abs(this.resolution - lastVal)) {
					// alert(this.resolution + '-' + videoResMaxVal + '=' +  Math.abs(this.resolution - videoResMaxVal) + ' ' + this.resolution + '-' + lastVal + '=' + Math.abs(this.resolution - lastVal))
					rightObj = urlData
					lastVal = videoResMaxVal
				}
				// lastVal = videoResMaxVal
			}

			this.currentSrc = rightObj.link
			this.currentType = rightObj.type
			this.currentPublicName = rightObj.public_name
		}
	},

	mounted() {
		this.checkResolution()
	}
}
</script>
